import Image from "../image/Image.tsx";

const UserLogo = ({
  src = "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/default_logo_organisation.png",
  isLarge = false,
  isMedium = false,
  isSmall = false,
}) => {
  let dimensions = "h-10 w-10";

  if (isLarge) {
    dimensions = "h-20 w-20";
  }
  if (isMedium) {
    dimensions = "h-10 w-10";
  }
  if (isSmall) {
    dimensions = "h-6 w-6";
  }

  return (
    <Image src={src} alt={"logo"} className={`rounded-full ${dimensions}`} />
  );
};

export default UserLogo;
